import { render, staticRenderFns } from "./EmrDrugNoneDrugTrx.vue?vue&type=template&id=4962eed8&"
import script from "./EmrDrugNoneDrugTrx.vue?vue&type=script&lang=js&"
export * from "./EmrDrugNoneDrugTrx.vue?vue&type=script&lang=js&"
import style0 from "./EmrDrugNoneDrugTrx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports